import { DefaultService } from "../DefaultService";

export default class AssClienteTabPrecoB2BEmpresaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    find(id) {
		return this._http.get(`${this._env}/b2b/b2bempresa/cliente/tabpreco/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
	}

    findAll(situacao, column, order, page = 0, limit = 20, idEmpresa = 0, ...params) {
        return this._http.get(encodeURI(`${this._env}/b2b/b2bempresa/cliente/tabpreco/findall.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}&situacao=${situacao}&idempresa=${idEmpresa}`), this._headers)
        .then(res => {
            return res.body;
        },
        err => {
            this.handleError(err);
        });
    }

    findAllCombo(idEmpresa = 0, ...params) {
		return this._http.get(encodeURI(`${this._env}/b2b/b2bempresa/cliente/tabpreco/getcombo/b2bempresas.json?idempresa=${idEmpresa}&param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
            this.handleError(err);
		});
	}

    updateSituacao(assClienteTipoPedidoB2BEmpresa) {
		return this._http.post(`${this._env}/b2b/b2bempresa/cliente/tabpreco/updatesituacao`, assClienteTipoPedidoB2BEmpresa, this._headers).then(res => {
			return res.body;
		}, err => {
			this.handleError(err);
		});
    }

    save(form) {
		return this._http.post(`${this._env}/b2b/b2bempresa/cliente/tabpreco`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
}